import React from 'react'
import Navbar from './components/Navbar'
import Hero from './components/Hero'
import Cards from './components/Cards'
import Food from './components/Food'
import Categories from './components/Categories'

function App() {
  return (
    <div>
      <Navbar/>
      <Hero/>
      <Cards/>
      <Food/>
      <Categories/>
    </div>
  )
}

export default App
